import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


import { LoginComponent } from './login/login.component';

import { AdmincolaboradoresComponent } from './admincolaboradores/admincolaboradores.component';
import { AdminextraescolaresComponent } from './adminextraescolares/adminextraescolares.component';
//import { AdmininscripcionesComponent } from './admininscripciones/admininscripciones.component';
import { AdminlandingComponent } from './adminlanding/adminlanding.component';
import { AdminayudaComponent } from './adminayuda/adminayuda.component';
import { AdminvideoayudaComponent } from './adminvideoayuda/adminvideoayuda.component';
import { AdminlistadosSociosComponent } from './adminlistados-socios/adminlistados-socios.component';
import { AdminlistadosUsuariosComponent } from './adminlistados-usuarios/adminlistados-usuarios.component';
import { AdminlistadosExtraescolaresComponent } from './adminlistados-extraescolares/adminlistados-extraescolares.component';
import { AdminlistadosEventosComponent } from './adminlistados-eventos/adminlistados-eventos.component';
import { AdmincontabilidadComponent } from './admincontabilidad/admincontabilidad.component';
import { AdmincolaboradoresCrearComponent } from './admincolaboradores-crear/admincolaboradores-crear.component';
//import { AdmingaleriaCrearComponent } from './admingaleria-crear/admingaleria-crear.component';
import { AdminextraescolaresCrearComponent } from './adminextraescolares-crear/adminextraescolares-crear.component';
import { AdminnoticiasComponent } from './adminnoticias/adminnoticias.component';
import { AdminnoticiasCrearComponent } from './adminnoticias-crear/adminnoticias-crear.component';
import { AdminextraescolaresGruposComponent } from './adminextraescolares-grupos/adminextraescolares-grupos.component';
import { AdminextraescolaresGruposCrearComponent } from './adminextraescolares-grupos-crear/adminextraescolares-grupos-crear.component';
import { AdmincentroescolarInformacionComponent } from './admincentro-escolar-informacion/admincentro-escolar-informacion.component';
import { AdmincentroEscolarInformacionCrearComponent } from './admincentro-escolar-informacion-crear/admincentro-escolar-informacion-crear.component';
import { AdmincentroescolarCursosComponent } from './admincentro-escolar-cursos/admincentro-escolar-cursos.component';
import { AdmincentroEscolarCursosCrearComponent } from './admincentro-escolar-cursos-crear/admincentro-escolar-cursos-crear.component';

import { AdminampaInformacionComponent } from './adminampa-informacion/adminampa-informacion.component';
import { AdminempresasComponent } from './adminempresas/adminempresas.component';
import { AdminempresasCrearComponent } from './adminempresas-crear/adminempresas-crear.component';
import { AdminampaInformacionCrearComponent } from './adminampa-informacion-crear/adminampa-informacion-crear.component';
import { AdminlistadosUsuariosCrearComponent } from './adminlistados-usuarios-crear/adminlistados-usuarios-crear.component';


export const router: Routes = [
  { path: '', component: LoginComponent },
  { path: 'main', component: AdminlandingComponent},
  { path: 'admin/colaboradores', component: AdmincolaboradoresComponent },
  { path: 'admin/extraescolares', component: AdminextraescolaresComponent },
  { path: 'admin/extraescolares/:state/:id', component: AdminextraescolaresCrearComponent },
  { path: 'admin/extraescolares-crear', component: AdminextraescolaresCrearComponent },

  { path: 'admin/ayuda', component: AdminayudaComponent },
  { path: 'admin/videoayuda', component: AdminvideoayudaComponent },
  { path: 'admin/listados-socios', component: AdminlistadosSociosComponent },
  { path: 'admin/listados-usuarios', component: AdminlistadosUsuariosComponent },
  { path: 'admin/listados-usuarios/:state/:id', component: AdminlistadosUsuariosCrearComponent },
  { path: 'admin/listados-usuarios-crear', component: AdminlistadosUsuariosCrearComponent },
  { path: 'admin/listados-extraescolares', component: AdminlistadosExtraescolaresComponent },
  { path: 'admin/listados-eventos', component: AdminlistadosEventosComponent },

  { path: 'admin/contabilidad', component: AdmincontabilidadComponent },
  { path: 'admin/colaboradores/:state/:id', component: AdmincolaboradoresCrearComponent },
  { path: 'admin/colaboradores-crear', component: AdmincolaboradoresCrearComponent },
  //{ path: 'admin/galeria-crear', component: AdmingaleriaCrearComponent },
  { path: 'admin/noticias', component: AdminnoticiasComponent },
  { path: 'admin/noticias-crear', component: AdminnoticiasCrearComponent },
  { path: 'admin/noticias/:state/:id', component: AdminnoticiasCrearComponent },
  { path: 'admin/extraescolares-grupos', component: AdminextraescolaresGruposComponent },
  { path: 'admin/extraescolares-grupos-crear', component: AdminextraescolaresGruposCrearComponent },
  //{ path: 'admin/ampa-cuotas-socios', component: AdminampaCuotasSociosComponent },
  { path: 'admin/centro-escolar-informacion', component: AdmincentroescolarInformacionComponent },
  { path: 'admin/centro-escolar-informacion-crear', component: AdmincentroEscolarInformacionCrearComponent },
  { path: 'admin/centro-escolar-informacion/:state/:id', component: AdmincentroEscolarInformacionCrearComponent },
  { path: 'admin/ampa-informacion', component: AdminampaInformacionComponent },
  { path: 'admin/ampa-informacion-crear', component: AdminampaInformacionCrearComponent },
  { path: 'admin/ampa-informacion/:state/:id', component: AdminampaInformacionCrearComponent },
  { path: 'admin/centro-escolar-cursos', component: AdmincentroescolarCursosComponent },
  { path: 'admin/centro-escolar-cursos-crear', component: AdmincentroEscolarCursosCrearComponent },
  { path: 'admin/centro-escolar-cursos/:state/:id', component: AdmincentroEscolarCursosCrearComponent },

  { path: 'admin/empresas', component: AdminempresasComponent },
  { path: 'admin/empresas/:state/:id', component: AdminempresasCrearComponent },
  { path: 'admin/empresas-crear', component: AdminempresasCrearComponent },




];

export const routes: ModuleWithProviders = RouterModule.forRoot(router);



// WEBPACK FOOTER //
// ./src/app/app.routes.ts